import React, { useState, useEffect, useCallback, memo } from "react";
import { FiSearch, FiX } from "react-icons/fi";
import "./CountryModal.css";

const CountryModal = ({
  visible,
  onClose,
  onSelectCountry,
  selectedCountry,
  countryList,
}) => {
  const [search, setSearch] = useState("");
  const [filteredList, setFilteredList] = useState(countryList);

  useEffect(() => {
    setSearch("");
    setFilteredList(countryList);
  }, [visible, countryList]);

  useEffect(() => {
    if (!search.trim()) {
      setFilteredList(countryList);
    } else {
      const lowerSearch = search.toLowerCase();
      setFilteredList(
        countryList.filter((item) =>
          item?.name?.toLowerCase()?.includes(lowerSearch)
        )
      );
    }
  }, [search, countryList]);


  const renderItem = useCallback(
    ({ item }) => {
      return (
        <div
          className={`country-modal-item ${
            selectedCountry?._id === item?._id ? "selected" : ""
          }`}
          onClick={() => onSelectCountry(item)}
        >
          <span className="country-modal-text">{item?.name}</span>
        </div>
      );
    },
    [onSelectCountry, selectedCountry]
  );

  if (!visible) return null;

  return (
    <div className="country-modal-overlay">
      <div className="country-modal-container">
        <div className="country-modal-header">
          <h2 className="country-modal-title">Select Country</h2>
          <button className="country-modal-close" onClick={onClose}>
            <FiX size={24} />
          </button>
        </div>
        <div className="country-modal-search">
          <FiSearch size={20} className="country-modal-search-icon" />
          <input
            className="country-modal-search-input"
            placeholder="Search country"
            value={search}
            onChange={(e) => setSearch(e.target.value)}
          />
        </div>
        <div className="country-modal-list">
          {filteredList.map((item) => (
            <div
              key={item?._id}
              className={`country-modal-item ${
                selectedCountry?._id === item?._id ? "selected" : ""
              }`}
              onClick={() => onSelectCountry(item)}
            >
              <span className="country-modal-text">{item?.name}</span>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
};

export default memo(CountryModal);
